
<template>
  <!--添加设备-->
  <x-addEdit
    :formList="formList"
    :formKey="formKey"
    :addParam="addParam"
    :editParam="editParam"
    :detailParam="detailParam"
  >
    <template slot="sncode" slot-scope="{formItem}">
      <a-form-item
        v-if="formItem.show"
        :label="formItem.label"
        v-bind="$store.state.base_itemLayout">
        <span class="ant-form-text">{{formData[formItem.props[0]]}}</span>
      </a-form-item>
    </template>

    <template slot="mac" slot-scope="{formItem}">
      <a-form-item
        v-if="formItem.show"
        :label="formItem.label"
        has-feedback
        v-bind="$store.state.base_itemLayout">
        <a-input v-decorator="formItem.props" :placeholder="formItem.placeholder" :disabled="formItem.disabled"/>
      </a-form-item>
    </template>

    <template slot="net_mac" slot-scope="{formItem}">
      <a-form-item
        v-if="formItem.show"
        :label="formItem.label"
        has-feedback
        v-bind="$store.state.base_itemLayout">
        <a-input v-decorator="formItem.props" :placeholder="formItem.placeholder" :disabled="formItem.disabled"/>
      </a-form-item>
    </template>

    <template slot="number" slot-scope="{formItem}">
      <a-form-item
        v-if="formItem.show"
        :label="formItem.label"
        has-feedback
        v-bind="$store.state.base_itemLayout">
        <a-input v-decorator="formItem.props" type="number" :placeholder="formItem.placeholder"/>
      </a-form-item>
    </template>
  </x-addEdit>
</template>

<script>
import { fetchSelect } from '../../../utils/mixins';
import Moment from 'moment';
export default {
  mixins: [fetchSelect],
  name: 'addDevice',
  data () {
    let decoratorOptions = {
      device_sncode: {rules: []},
      product_id: {
        rules: [{ required: true, message: '请选择产品型号' }]
      },
      production_batch: {
        validateTrigger: 'blur',
        rules: [
          { required: true, message: '请输入生产批次' },
          { pattern: this.REG.code, message: this.MESSAGE.code }
        ]
      },
      hardware_version: {
        validateTrigger: 'blur',
        rules: [
          { required: true, message: '请输入硬件版本' },
          { pattern: this.REG.code, message: this.MESSAGE.code }
        ]
      },
      production_time: {
        rules: [{required: true, message: '请选择生产时间'}]
      },
      number: {
        validateTrigger: 'blur',
        rules: [{required: true, message: '请输入生产数量'}]
      }
    };
    return {
      formData: {},
      formList: [
        {
          slot: 'sncode',
          show: false,
          label: '设备编码',
          inputType: 'text',
          options: [],
          placeholder: '',
          props: ['device_sncode', decoratorOptions.device_sncode]
        },
        {
          label: '产品型号',
          inputType: 'select',
          options: [],
          placeholder: '请选择上产品型号',
          props: ['product_id', decoratorOptions.product_id]
        },
        {
          label: '生产批次',
          inputType: 'input',
          options: [],
          placeholder: '请输入生产批次',
          props: ['production_batch', decoratorOptions.production_batch]
        },
        {
          label: '硬件版本',
          inputType: 'input',
          options: [],
          placeholder: '请输入硬件版本',
          props: ['hardware_version', decoratorOptions.hardware_version]
        },
        {
          disabled: false,
          label: '生产时间',
          inputType: 'datePick',
          options: [],
          placeholder: '请输入生产时间',
          props: ['production_time', decoratorOptions.production_time]
        },
        {
          slot: 'number',
          label: '生产数量',
          inputType: 'inputNumber',
          options: [],
          placeholder: '请输入生产数量',
          show: true,
          props: ['number', decoratorOptions.number]
        },
        {
          slot: 'mac',
          show: false,
          label: '蓝牙MAC地址',
          inputType: 'input',
          options: [],
          placeholder: '请输入蓝牙MAC地址',
          props: ['mac']
        },
        {
          slot: 'net_mac',
          show: false,
          label: '以太网MAC地址',
          inputType: 'input',
          options: [],
          placeholder: '以太网MAC地址',
          props: ['net_mac']
        }
      ],
      formKey: {
        device_sncode: '',
        product_id: '',
        production_batch: '',
        hardware_version: '',
        production_time: '',
        number: '',
        mac: '',
        net_mac: ''
      },
      addParam: {
        url: '/basis_info/add',
        reqHandle: this.reqHandle, // this.reqHandle
        resHandle: '' // this.addResHandle
      },
      editParam: {
        url: '/basis_info/edit/',
        resHandle: '' // this.editResHandle
      },
      detailParam: {
        url: '/basis_info/',
        resHandle: this.detailResHandle
      }
    };
  },
  created () {
    this.deviceManageSelect([{index: 1, key: 'product_type', scope: 'formList'}]);
    if (this.$route.query.id) {
      this.formList.forEach((el) => {
        el.props && el.props[0] === 'net_mac' && (el.show = el.disabled = true);
        el.slot === 'mac' && (el.show = el.disabled = true);
        el.inputType === 'datePick' && (el.disabled = true);
        el.inputType === 'text' && (el.show = true);
        el.slot === 'number' && (el.show = false);
        if (el.props && el.props[0] === 'production_batch') {
          el.disabled = true;
        }
      });
    }
  },
  methods: {
    detailResHandle (data) {
      let formValues = {};
      formValues.production_time = Moment(data.production_time);
      formValues.product_id = parseInt(data.product_id);
      this.formData = {device_sncode: data.device_sncode};
      return formValues;
    },
    reqHandle (param) {
      param.production_time = param.production_time.format('YYYY-MM-DD');
      return param;
    },
    addResHandle (res) {
      return res;
    },
    editResHandle (res) {
      return res;
    }
  }
};
</script>
